import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddPlayroomModalComponent } from 'src/app/admin/components/modals/add-playroom-modal/add-playroom-modal.component';
import { DeletePlayroomModalComponent } from 'src/app/admin/components/modals/delete-playroom-modal/delete-playroom-modal.component';
import { EditPlayroomModalComponent } from 'src/app/admin/components/modals/edit-playroom-modal/edit-playroom-modal.component';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { UserService } from 'src/app/admin/services/user.service';

@Component({
  selector: 'app-manage-playrooms-page',
  templateUrl: './manage-playrooms.page.html',
  styleUrls: ['./manage-playrooms.page.scss'],
})

export class ManagePlayroomsPage implements OnInit {

  playrooms$ = this.roomService.playrooms$;
  managers = [];

  constructor(private roomService: PlayroomService, private modalController: ModalController, private userService: UserService) {}

  ngOnInit(): void {
    this.roomService.getAllPlayrooms();

    this.userService.getAllUsers({currentPage: 1, itemsPerPage: 100, usernameQuery: '',
    firstNameQuery: '', lastNameQuery: '', idCardNoQuery: ''}); // TODO: replace this method with request that directly fetches managers.
    // TODO: replace this method with request that directly fetches managers.
    this.userService.allUsers$.subscribe(allUsers => {
      this.managers = allUsers.filter(e => e.role === 'Manager');
    });
 
 
  }

  async openAddRoomModal() {
    const modal = await this.modalController.create({
      component: AddPlayroomModalComponent,
      componentProps: {managers: this.managers},
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });

    await modal.present();
  }

  async openDeleteRoomModal(room) {
    const modal = await this.modalController.create({
      component: DeletePlayroomModalComponent,
      componentProps: {room},
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openEditRoomModal(room) {
    const modal = await this.modalController.create({
      component: EditPlayroomModalComponent,
      componentProps: {room: {...room}, managers: this.managers},
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  getFullNameOrSlash(user) {
    return user ? `${user.firstName} ${user.lastName}` : '/';
  }

  getWorkingHours(room) {
    const from = new Date(room.workingHoursFrom).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    const to = new Date(room.workingHoursTo).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    return `${from} - ${to}`;
  }

}
